import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ConfirmationModalComponent } from 'src/app/account/modals/confirmation-modal/confirmation-modal.component';
import { ModalService } from 'src/app/core/modal.service';
import { NotificationService } from 'src/app/core/notification.service';
import { UsersService } from 'src/app/core/users.service';
import { ApplicationFeedback } from 'src/app/shared/interfaces/api-response';
import { UserRecord } from 'src/app/shared/interfaces/user-record';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit, OnDestroy {
  public subscription: Subscription = new Subscription;
  public users: UserRecord[] | null = null
  public filteredUsers: UserRecord[] | null = null
  public loadingUsers = false
  public totalCount = 0
  public userSearchForm = new FormGroup({
    filter: new FormControl<string>("", { nonNullable: true })
  })

  constructor(private notificationService: NotificationService,
              private usersService: UsersService,
              private modalService: ModalService) { }

  ngOnInit() {
    this.loadAllUsers()
  }

  ngOnDestroy(){
    if(this.subscription){
      this.subscription.unsubscribe()
    }
  }

  loadAllUsers() {
    this.loadingUsers = true;
    this.usersService.getAllUsers().then((result: UserRecord[]) => {
      if(result.length === 0){
        this.notificationService.displayError("Server returned no users")
      } else {
        this.loadAllUsersCompleted(result)
      }
    })
  }

  loadAllUsersCompleted(result: UserRecord[]) {
    this.loadingUsers = false;
    this.users = result;
    this.filteredUsers = this.users
    if (this.users) {
      this.totalCount = this.users.length;
    } else {
      this.totalCount = 0
    }
  }

  deleteUserClicked(id: number){
    if(this.users == null){
      this.notificationService.displayError("No Users Loaded")
      return
    }
    const deleteRecord = this.users.find((user) => user.ID === id)
    const state = {
      title: "Confirm Deletion",
      text: "Are you sure you want to delete user: " + deleteRecord?.Username + "?"
    }
    this.modalService.openModal(ConfirmationModalComponent, state)
    this.subscription = this.modalService.submitClicked.asObservable().subscribe((confirmation) => {
      if(confirmation){
        this.deleteUser(id)
        // Set submitClicked in the modalService back to false, if this is not done the modal will immediatly close and return true when next opened
        this.modalService.submitClicked.next(false)
      }
      // Now that modal is closed, we no longer need the subscription to it.
      this.subscription.unsubscribe()
    })
  }

  deleteUser(id: number) {
    this.usersService.deleteUser(id).then((result: ApplicationFeedback) => {
      if(result.success){
        this.deleteUserCompleted(result)
      } else {
        this.notificationService.displayError(String(result.message))
      }
    })
  }

  deleteUserCompleted(result: ApplicationFeedback) {
    this.notificationService.displaySuccess(String(result.message));
    this.loadAllUsers();
  }

  search(){
    // search through every member of the users array for a match
    const result = this.users?.filter((user) =>{
      // Search through every member of each user Object for a match
      for (const value of Object.values(user)){
        // Find match if the search value is a substring of the Objects' value
        if(String(value).toLowerCase().includes(String(this.userSearchForm.value.filter).toLowerCase())){
          return true
        }
      }
      return false
    })
    // if (a) match(es) is(are) found set the filteredUsers to only the matching records
    // if no match foundset the array to be empty
    if(result){
      this.filteredUsers = result
    } else {
      this.filteredUsers = null
    }
  }

  clearSearch(){
    this.userSearchForm.setValue({filter: ""})
    this.filteredUsers = this.users
  }
}
